import React, { useContext } from 'react';
import { IProduct, IVariant, TUserSelection } from '../../../types/PDP';
import { IDropdownItemsData, ButtonVariantSelectorProps } from '../types';
import { PurchaseLimitTagDataTypes } from 'src/scripts/templates/_shared/ui-components/PurchaseLimitItem/PurchaseLimitMessaging';
import { getCartData } from 'src/scripts/utils/cart';
import { hasMetLimitedProductCartQuantity } from 'src/scripts/templates/_shared/ui-components/PurchaseLimitItem/PurchaseLimitMessaging';
import { UrgencyMessage } from '../../ScarcityMessaging/UrgencyMessage';
import './styles.scss';
import { ProductContext } from '../../../ProductContext';
import { scrollToNotifyField } from '../../../utils';
import { checkIfItemCanBeSoldOut } from 'src/scripts/utils/helpers';

const ButtonsVariantSelector = ({
  product,
  userSelection,
  productIndex,
  optionName,
  updateSelection,
  isASet,
  dropdownItemsData,
  purchaseLimitTagData,
  error,
}: ButtonVariantSelectorProps) => {
  const { changeIsModalOpenByATCbutton, toggleSelectionError } = useContext(ProductContext);

  const onSelect = (optionValue: string, isSoldOut: boolean) => {
    updateSelection(productIndex, optionName, optionValue);
    setTimeout(() => {
      scrollToNotifyField(productIndex);
    }, 0);
    if (isSoldOut && !isASet) {
      changeIsModalOpenByATCbutton(false);
      toggleSelectionError(false);
    }
  };

  let maxText = getMaxTextLength(dropdownItemsData);

  return (
    <>
      <ShowUrgencyMessage
        product={product}
        userSelection={userSelection}
        dropdownItemsData={dropdownItemsData}
        isASet={isASet}
        purchaseLimitTagData={purchaseLimitTagData}
      />
      <div className={`button-size-selector ${error ? 'error' : ''}`}>
        <ul className={`button-size-selector__list ${maxText > 10 ? `col_2` : maxText > 3 ? 'col_3' : 'col_4'}`}>
          {dropdownItemsData.map((option) => {
            const {
              optionValue,
              variant,
              isActive,
              availableForSale,
              shouldHideInventory,
              isPhasedOutProduct,
              sizeMappedInfo,
            } = option;

            const cartData = getCartData();
            const hasMetATCLimit =
              purchaseLimitTagData && hasMetLimitedProductCartQuantity(cartData, variant?.sku, purchaseLimitTagData);

            const isSoldOut = checkIfItemCanBeSoldOut(product.productDataByColorName[userSelection.Color ?? '']?.tags)
              ? !availableForSale || hasMetATCLimit || shouldHideInventory
              : false;

            const shouldShowNotifyMe = !isPhasedOutProduct && (!availableForSale || shouldHideInventory);

            const notifyMe = (!isPhasedOutProduct && !availableForSale && !isASet && variant) || shouldShowNotifyMe;

            return (
              <li className={`button-size-selector__item`}>
                <button
                  className={`button-size-selector__button ${isSoldOut ? 'out-of-stock' : ''} ${
                    notifyMe ? 'notify-me' : ''
                  } ${isActive ? 'active' : ''}`}
                  onClick={() => {
                    onSelect(optionValue, isSoldOut);
                  }}
                >
                  {notifyMe ? <span className="alo-bell-plus-icon"></span> : null}
                  <span>{`${optionValue} ${sizeMappedInfo}`.trim()}</span>
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

const getMaxTextLength = (dropdownItemsData: IDropdownItemsData[]) => {
  let length: number = 0;
  dropdownItemsData.forEach((option) => {
    const { optionValue, sizeMappedInfo } = option;
    const stringLength = `${optionValue}${sizeMappedInfo}`.length;
    length = length < stringLength ? stringLength : length;
  });
  return length;
};

const ShowUrgencyMessage = ({
  dropdownItemsData,
  isASet,
  purchaseLimitTagData,
  product,
  userSelection,
}: {
  dropdownItemsData: IDropdownItemsData[];
  isASet: boolean;
  purchaseLimitTagData?: PurchaseLimitTagDataTypes;
  product: IProduct;
  userSelection: TUserSelection;
}) => {
  const option = dropdownItemsData.find((option) => option.isActive) || {};
  const {
    variant,
    availableForSale,
    quantityXLeft = 0,
    shouldHideInventory,
    isPhasedOutProduct,
    unlimitedInventory,
  }: {
    availableForSale?: boolean;
    quantityXLeft?: number;
    variant?: IVariant;
    shouldHideInventory?: boolean;
    isPhasedOutProduct?: boolean;
    unlimitedInventory?: boolean;
  } = option;

  const cartData = getCartData();
  const productDataForColor = product.productDataByColorName[userSelection.Color || ''];
  const { totalInventory = 0 } = productDataForColor || {};
  const hasMetATCLimit =
    purchaseLimitTagData && hasMetLimitedProductCartQuantity(cartData, variant?.sku, purchaseLimitTagData);
  const isSoldOut = checkIfItemCanBeSoldOut(productDataForColor?.tags)
    ? !availableForSale || hasMetATCLimit || shouldHideInventory || totalInventory === 0
    : false;
  const shouldShowNotifyMe = !isPhasedOutProduct && (!availableForSale || shouldHideInventory);
  const notifyMe = (!isPhasedOutProduct && !availableForSale && !isASet && variant) || shouldShowNotifyMe;
  let shouldShowUrgencyMessage = true;

  if (!availableForSale || shouldHideInventory) {
    shouldShowUrgencyMessage = false;
  }
  const showSoldOutMessage = isSoldOut && !notifyMe && quantityXLeft <= 0;
  return !unlimitedInventory && !isASet && (shouldShowUrgencyMessage || showSoldOutMessage) ? (
    <UrgencyMessage
      quantityLeft={showSoldOutMessage ? 0 : quantityXLeft}
      className="buttonSelector"
      style={{ color: 'var(--primary)' }}
    />
  ) : null;
};

export default ButtonsVariantSelector;
